import React, { useState, useEffect, useRef } from 'react'
import {
	Avatar,
	ButtonBase,
	Card,
	CardHeader,
	CardContent,
	Checkbox,
	Icon,
	ListItemText,
	makeStyles,
	MenuItem,
	TextField,
	Typography,
	useTheme,
	CardActions,
	Button
} from '@material-ui/core'

import { DeletableChip } from '../../Misc/DeletableChip'

import { ArrowBackIosOutlined, ArrowForwardIosOutlined } from '@material-ui/icons'

import { KeyboardDatePicker } from '@material-ui/pickers'

import moment from 'moment'
import clsx from 'clsx'
import { useDispatch, useSelector } from 'react-redux'

import { colors, getPetAge } from '../../../services/helpers'

import Autocomplete from '@material-ui/lab/Autocomplete'

import { cloneDeep } from 'lodash'

import { uploadPetProfilePhoto, updatePet, deletePet } from '../../../actions/pets/pets.actions'

import LoadingOverlayContained from '../../Misc/LoadingOverlayContained'
import { showSuccess } from '../../../actions/misc/misc.actions'
import Confirmation from '../../Dialogs/Misc/Confirmation'
import { useHistory } from 'react-router-dom'

const heightOptions = ['xs', 's', 'm', 'l', 'xl']

const useStyles = makeStyles((theme) => ({
	grid: {
		display: 'grid',
		gridGap: '23px',
		gridTemplateColumns: '250px 300px',
		marginBottom: '23px'
	},
	gridTwo: {
		display: 'grid',
		gridGap: '23px',
		gridTemplateColumns: 'repeat(auto-fill, minmax(424px, 1fr))',
		'& .field-wrapper': {
			'& .MuiTextField-root': {
				minWidth: '424px !important'
			}
		}
	},
	gridDouble: {
		display: 'grid',
		gridGap: '23px',
		gridTemplateColumns: 'repeat(auto-fill, minmax(424px, 1fr))',
		'& .field-wrapper': {
			'& .MuiTextField-root': {
				minWidth: '424px !important'
			}
		}
	},
	fileUpload: {
		gridColumn: 'auto / span 1',
		gridRow: 'auto / span 3',
		justifySelf: 'center'
	},
	fieldWrapper: {
		// display: 'flex',
		// flexDirection: 'row',
		// justifyContent: 'space-between',
		display: 'grid',
		gridGap: '23px',
		gridTemplateColumns: '274px 274px',
		'& .MuiTextField-root': {
			minWidth: '274px !important'
		}
	},
	imageUploadButton: {
		height: 208,
		width: 208,
		background: 'transparent',
		borderRadius: '50%',
		border: '1px solid #D0CFD2',
		'&:hover': {
			borderColor: theme.palette.secondary.main
		}
	},
	fileUploadWrapper: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		flexDirection: 'column'
	},
	fileUploadIcon: {
		'&::before': {
			color: '#6B4AD6'
		}
	},
	input: {
		display: 'none'
	},
	petProfileImage: {
		width: '100%',
		height: '100%'
	},
	datePicker: {
		margin: 0
	},
	calendarHeaderButtons: {
		fill: theme.palette.primary.main
	},
	calendarButton: {
		'& svg': {
			fill: '#777679'
		}
	},
	autoComplete: {
		'& .MuiFilledInput-root': {
			paddingTop: '17px'
		},
		'& .Mui-focused': {
			'& .MuiAutocomplete-endAdornment svg': {
				fill: theme.palette.secondary.main
			}
		},
		'& .MuiAutocomplete-endAdornment svg': {
			fill: '#777679'
		}
	},
	deleteButton: {
		color: '#D32F2F',
		borderColor: '#D32F2F',
		'&:hover': {
			color: '#FFFFFF',
			backgroundColor: '#D32F2F'
		}
	},
	cardActions: {
		justifyContent: 'space-between'
	}
}))

const PetInfoCard = (props) => {
	const classes = useStyles()
	const theme = useTheme()
	const dispatch = useDispatch()
	const inputRef = useRef(null)
	const history = useHistory()

	const facility = useSelector((state) => state.specific.facilities.selected)
	const { breeds } = facility
	const household = useSelector((state) => state.specific.households.selected)
	const loading = useSelector((state) => state.specific.households.loading)
	const error = useSelector((state) => state.specific.households.error)

	let { pet, setPet } = props

	let petSexOptions = ['Intact Male', 'Neutered Male', 'Intact Female', 'Spayed Female', 'Unknown']

	const temperamentTestStatusOptions = ['Unscheduled', 'Scheduled', 'Passed', 'Failed']

	const origins = ['Breeder', 'Foster', 'Shelter Rescue']

	const [isOpen, setIsOpen] = useState(false)
	const [petBreeds, setPetBreeds] = useState('')
	const [petColors, setPetColors] = useState('')

	const [isDeactivationDialogShown, setIsDeactivationDialogShown] = useState(false)
	const [isDeleteDialogShown, setIsDeleteDialogShown] = useState(false)
	const [isActivationDialogShown, setIsActivationDialogShown] = useState(false)

	useEffect(() => {
		if (pet) {
			setPetBreeds(pet?.breeds?.filter(b => typeof b === 'string') || [])
			setPetColors(!pet.color || pet.color.length === 0 ? [] : pet.color.split(','))
		}
	}, [pet])

	const renderImageUpload = () => (
		<div className={classes.fileUploadWrapper}>
			<Icon className={clsx(['fas fa-image', classes.fileUploadIcon])} />
			<Typography variant="body2" style={{ color: theme.palette.secondary.main }}>
				Upload Picture *
			</Typography>
		</div>
	)

	const uploadPhoto = (e) => {
		let file

		if (e.target.files && e.target.files.length && e.target.files[0]) {
			file = e.target.files[0]

			const data = new FormData()
			data.append('profile_image', file)

			dispatch(uploadPetProfilePhoto(pet._id, data)).then(() => {
				inputRef.current.value = null
			})
		}
	}

	const updatePetBirthday = (date) => {
		setPet({ ...pet, birthday: moment(date).hour(12) })
		setIsOpen(false)
	}

	const getPetSize = () => {
		if (pet.height) return pet.height.toUpperCase();
		if (pet.weight <= 12) {
			return 'XS'
		} else if (pet.weight >= 13 && pet.weight < 31) {
			return 'S'
		} else if (pet.weight >= 31 && pet.weight < 48) {
			return 'M'
		} else if (pet.weight >= 48 && pet.weight < 71) {
			return 'L'
		} else if (pet.weight >= 71) {
			return 'XL'
		} else {
			return null
		}
	}

	const updatePetBreeds = (value) => {
		let updatedPet = cloneDeep(pet)
		let currentBreeds = [...value]
		
		if (currentBreeds.length > 2) return

		setPet({ ...updatedPet, breeds: currentBreeds })
	}

	const removeBreed = (breed) => {
		let updatedPet = cloneDeep(pet)
		let currentBreeds = [...petBreeds]

		let breedIndex = currentBreeds.findIndex((b) => b === breed)

		if (breedIndex !== -1) {
			currentBreeds.splice(breedIndex, 1)
		}


		setPet({ ...updatedPet, breeds: currentBreeds })
	}

	const updatePetColors = (value) => {
		let updatedPet = cloneDeep(pet)
		let currentColors = [...value]
		currentColors = currentColors.join(',')

		setPet({ ...updatedPet, color: currentColors })
	}

	const removeColor = (color) => {
		let updatedPet = cloneDeep(pet)
		let currentColors = [...petColors]

		let colorIndex = currentColors.findIndex((c) => c === color)

		if (colorIndex !== -1) {
			currentColors.splice(colorIndex, 1)
		}

		currentColors = currentColors.length > 0 ? currentColors.join(',') : ''

		setPet({ ...updatedPet, color: currentColors })
	}

	const updatePetActiveStatus = (active) => {
		let updates = {
			active
		}

		dispatch(updatePet(pet._id, updates))
	}

	const remove = () => {
		dispatch(deletePet(pet._id)).then(() => {
			history.push(`/clients/${household._id}/pets`)
		})
	}

	return (
		<Card>
			<CardHeader title="General Info" />
			<CardContent>
				<div className={classes.grid}>
					<div className={classes.fileUpload}>
						<input
							accept="image/*"
							className={classes.input}
							id="icon-button-file"
							type="file"
							disabled={!pet.active}
							ref={inputRef}
							onChange={(e) => uploadPhoto(e)}
						/>
						<label htmlFor="icon-button-file" style={{ position: 'relative' }}>
							{loading ? <LoadingOverlayContained /> : null}
							<ButtonBase
								className={classes.imageUploadButton}
								component="span"
								disabled={!pet.active}>
								{pet.image_url ? (
									<Avatar className={classes.petProfileImage} src={pet.image_url} />
								) : (
									renderImageUpload()
								)}
							</ButtonBase>
						</label>
					</div>
					<div className={classes.gridTwo}>
					<div className={classes.fieldWrapper}>
						<TextField
							label="Pet Name *"
							variant="filled"
							value={pet.name}
							disabled={!pet.active}
							onChange={(e) => setPet({ ...pet, name: e.target.value })}
						/>
						<TextField
							select
							label="Animal Type *"
							variant="filled"
							value={pet.animal_type ? pet.animal_type.toLowerCase() : ''}
							disabled={!pet.active}
							onChange={(e) => setPet({ ...pet, animal_type: e.target.value })}>
							<MenuItem value="dog">Dog</MenuItem>
							<MenuItem value="cat">Cat</MenuItem>
						</TextField>
					</div>
					<div className={classes.fieldWrapper}>
						<KeyboardDatePicker
							disableToolbar
							open={isOpen}
							onOpen={() => setIsOpen(true)}
							onClose={() => setIsOpen(false)}
							variant="inline"
							format="MM/DD/YYYY"
							margin="normal"
							id="pet-birthday"
							label="Birthday"
							inputVariant="filled"
							value={pet.birthday || null}
							onChange={(date) => updatePetBirthday(date)}
							className={classes.datePicker}
							disabled={!pet.active}
							rightArrowIcon={<ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />}
							leftArrowIcon={<ArrowBackIosOutlined className={classes.calendarHeaderButtons} />}
							KeyboardButtonProps={{
								'aria-label': 'Birthday',
								className: classes.calendarButton
							}}
						/>
						<TextField
							label="Age"
							variant="filled"
							value={getPetAge(pet.birthday) || '--'}
							disabled
							className="calculated-field"
							onChange={(e) => setPet({ ...pet, age: e.target.value })}
						/>
					</div>
					<div className={classes.fieldWrapper}>
						<Autocomplete
							multiple
							disableCloseOnSelect
							size="small"
							id="breed"
							className={classes.autoComplete}
							options={breeds || []}
							value={petBreeds && petBreeds.length ? petBreeds : []}
							onChange={(e, v) => updatePetBreeds(v)}
							onClose={(e) => {
								e.target.value = ''
							}}
							disabled={!pet.active || pet?.animal_type?.toLowerCase() !== 'dog'}
							renderTags={(selected) =>
								selected.map((value) => (
									<DeletableChip
										key={value}
										label={value}
										{...{
											onDelete: pet.active ? () => removeBreed(value) : null
										}}
									/>
								))
							}
							renderOption={(option, { selected }) => (
								<React.Fragment>
									<Checkbox checked={selected} />
									<ListItemText style={{ textTransform: 'capitalize' }} primary={option} />
								</React.Fragment>
							)}
							renderInput={(params) => (
								<TextField {...params} variant="filled" fullWidth label="Breed" />
							)}
						/>
						<Autocomplete
							multiple
							disableCloseOnSelect
							size="small"
							id="color"
							className={classes.autoComplete}
							options={colors || []}
							value={petColors || []}
							onChange={(e, v) => updatePetColors(v)}
							onClose={(e) => {
								e.target.value = ''
							}}
							disabled={!pet.active}
							renderTags={(selected) =>
								selected.map((value) => (
									<DeletableChip
										key={value}
										label={value}
										{...{
											onDelete: pet.active ? () => removeColor(value) : null
										}}
									/>
								))
							}
							renderOption={(option, { selected }) => (
								<React.Fragment>
									<Checkbox checked={selected} />
									<ListItemText style={{ textTransform: 'capitalize' }} primary={option} />
								</React.Fragment>
							)}
							renderInput={(params) => (
								<TextField {...params} variant="filled" fullWidth label="Color" />
							)}
						/>
					</div>
					<div className={classes.fieldWrapper}>
						<TextField
							label="Weight"
							variant="filled"
							InputProps={{
								type: 'number'
							}}
							value={pet.weight}
							disabled={!pet.active}
							onChange={(e) => setPet({ ...pet, weight: e.target.value })}
						/>
						<TextField
							label="Height"
							variant="filled"
							InputProps={{
								type: 'number',
								style: { textTransform: 'uppercase' }
							}}
							value={pet?.height || ''}
							select
							disabled={!pet.active}
							onChange={(e) => setPet({ ...pet, height: e.target.value })}
						>
						{heightOptions.map((h) => (
							<MenuItem key={h} value={h} style={{ textTransform: 'uppercase' }}>
								{h}
							</MenuItem>
						))}
						</TextField>
					</div>
					<div className={classes.fieldWrapper}>
					<TextField
						label="Size"
						variant="filled"
						disabled
						className="calculated-field"
						value={getPetSize() || '--'}
					/>
						<TextField
							select
							label="Sex *"
							variant="filled"
							value={pet.sex}
							disabled={!pet.active}
							onChange={(e) => setPet({ ...pet, sex: e.target.value })}>
							{petSexOptions.map((sex) => (
								<MenuItem key={sex} value={sex}>
									{sex}
								</MenuItem>
							))}
						</TextField>
					</div>

					</div>
				</div>
				{/* <div className={classes.gridDouble}>
          <div className={clsx([classes.fieldWrapper, "field-wrapper"])}>
            <div className={classes.fieldWrapper}>
              <TextField
                select
                label="Pet Origin"
                variant="filled"
                value={pet.origin}
                disabled={!pet.active}
                onChange={(e) => setPet({ ...pet, origin: e.target.value })}
              >
                {origins.map((origin) => (
                  <MenuItem key={origin} value={origin}>
                    {origin}
                  </MenuItem>
                ))}
              </TextField>
            </div>
          </div>
          <div className={clsx([classes.fieldWrapper, "field-wrapper"])}>
            <TextField
              select
              label="Compatibility Session Status"
              variant="filled"
              value={pet.temperament_test_status}
              disabled={!pet.active}
              onChange={(e) =>
                setPet({ ...pet, temperament_test_status: e.target.value })
              }
            >
              {temperamentTestStatusOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </div>
        </div> */}
			</CardContent>
			<CardActions className={classes.cardActions}>
				{/* <Button
          variant="outlined"
          className={ classes.deleteButton }
          onClick={() => setIsDeleteDialogShown(true)}
        >
          Delete Pet
        </Button> */}
				<div></div>
				{pet.active ? (
					<Button
						variant="outlined"
						className={classes.deleteButton}
						onClick={() => setIsDeactivationDialogShown(true)}>
						Deactivate Pet
					</Button>
				) : (
					<Button variant="outlined" color="secondary" onClick={() => setIsActivationDialogShown(true)}>
						Activate Pet
					</Button>
				)}
			</CardActions>
			<Confirmation
				title="Activate Pet"
				isShown={isActivationDialogShown}
				setIsShown={setIsActivationDialogShown}
				confirm={() => updatePetActiveStatus(true)}
				confirmTitle={'Activate'}
				message={'This action will allow this individual pet to be used in the system.'}
			/>
			<Confirmation
				title="Deactivate Pet"
				isShown={isDeactivationDialogShown}
				setIsShown={setIsDeactivationDialogShown}
				confirm={() => updatePetActiveStatus(false)}
				confirmTitle={'Deactivate'}
				message={'This action will lock this individual pet out of the system. It will remove the pet from all future visits. Any visits where this pet is the only dog will be deleted.'}
			/>
			<Confirmation
				title="Remove Pet"
				isShown={isDeleteDialogShown}
				setIsShown={setIsDeleteDialogShown}
				confirm={() => remove()}
				confirmTitle={'Remove'}
				message={'This action will remove this individual pet and cannot be undone.'}
			/>
		</Card>
	)
}

export default PetInfoCard
